import { cloneElement, isValidElement, ReactElement } from 'react';

import { TProps } from './types/TProps';

const iconBaseClassName = [
  'icon absolute right-[15px] top-1/2 z-10 block h-5 w-5 -translate-y-1/2 select-none',
  '!text-[var(--color-form-field-icon,var(--color-text-muted))]',
  'enabled:hover:!text-[var(--color-form-field-icon,var(--color-text-muted))]',
].join(' ');

const decorativeIconClassName = 'pointer-events-none';

const clickableIconClassName = 'icon--clickable cursor-pointer [&_svg]:cursor-pointer';

export const FormFieldIcon = ({ clickable = false, className = '', children }: TProps) => {
  const resolvedClassName = [iconBaseClassName, clickable ? clickableIconClassName : decorativeIconClassName, className]
    .filter(Boolean)
    .join(' ');

  if (isValidElement(children)) {
    const child = children as ReactElement<{ className?: string }>;
    return cloneElement(child, {
      className: [resolvedClassName, child.props.className].filter(Boolean).join(' '),
    });
  }

  return <span className={resolvedClassName}>{children}</span>;
};
